import { Button, Grid } from "@mui/material";

// Calculator digit buttons
interface ButtonDigitProps {
    digit: string;
    enterDigit: (digit: string) => void;
    xs?: number;
  }
export const ButtonDigit: React.FC<ButtonDigitProps> = ({ digit, enterDigit, xs = 3 }) => {
    return (
      <Grid item xs={ xs }>
        <Button 
        fullWidth 
        variant="outlined" 
        onClick={
            () => enterDigit(digit)
        }>
            { digit }
        </Button>
      </Grid>
    )
  }